import { Box, Typography, Grid, useTheme } from "@mui/material";
import { tokens } from "../../theme";
import { mockTransactions } from "../../data/mockData";
import EmailIcon from "@mui/icons-material/Email";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import TrafficIcon from "@mui/icons-material/Traffic";
import Header from "../../components/Header";
import GeographyChart from "../../components/GeographyChart";
import BarChart from "../../components/BarChart";
import StatBox from "../../components/StatBox";
import ProgressCircle from "../../components/ProgressCircle";

const Dashboard = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Box m="20px">
      {/* HEADER */}
      <Box mb="30px">
        <Header title="DASHBOARD" />
      </Box>

      {/* GRID & CHARTS */}
      <Grid container spacing={3}>
        {/* ROW 1 */}
        <Grid item xs={12} sm={6} md={3}>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            p="20px"
            backgroundColor={colors.primary[400]}
            borderRadius="12px"
            boxShadow={`0 4px 12px ${colors.grey[700]}`}
          >
            <StatBox
              title="8,932"
              subtitle="Products Sold"
              progress="0.65"
              increase="+25%"
              icon={<EmailIcon sx={{ color: colors.blueAccent[600], fontSize: "28px" }} />}
            />
          </Box>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            p="20px"
            backgroundColor={colors.primary[400]}
            borderRadius="12px"
            boxShadow={`0 4px 12px ${colors.grey[700]}`}
          >
            <StatBox
              title="289,761"
              subtitle="Revenue Generated"
              progress="0.70"
              increase="+18%"
              icon={<PointOfSaleIcon sx={{ color: colors.blueAccent[600], fontSize: "28px" }} />}
            />
          </Box>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            p="20px"
            backgroundColor={colors.primary[400]}
            borderRadius="12px"
            boxShadow={`0 4px 12px ${colors.grey[700]}`}
          >
            <StatBox
              title="48,123"
              subtitle="Active Users"
              progress="0.55"
              increase="+8%"
              icon={<PersonAddIcon sx={{ color: colors.blueAccent[600], fontSize: "28px" }} />}
            />
          </Box>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            p="20px"
            backgroundColor={colors.primary[400]}
            borderRadius="12px"
            boxShadow={`0 4px 12px ${colors.grey[700]}`}
          >
            <StatBox
              title="2,598,765"
              subtitle="Website Visits"
              progress="0.85"
              increase="+50%"
              icon={<TrafficIcon sx={{ color: colors.blueAccent[600], fontSize: "28px" }} />}
            />
          </Box>
        </Grid>

        {/* ROW 2 */}
        <Grid item xs={12} md={6} lg={4}>
          <Box
            backgroundColor={colors.primary[400]}
            p="20px"
            borderRadius="12px"
            boxShadow={`0 4px 12px ${colors.grey[700]}`}
            height="100%"
            display="flex"
            flexDirection="column"
          >
            <Typography color={colors.grey[100]} variant="h6" fontWeight="600" mb="15px">
              Recent Transactions
            </Typography>
            {mockTransactions.map((transaction, i) => (
              <Box
                key={`${transaction.txId}-${i}`}
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                borderBottom={`1px solid ${colors.grey[700]}`}
                p="10px"
                sx={{ '&:last-child': { borderBottom: 'none' } }}
              >
                <Box>
                  <Typography color={colors.greenAccent[500]} variant="h6" fontWeight="600">
                    {transaction.txId}
                  </Typography>
                  <Typography color={colors.grey[100]} variant="body2">
                    {transaction.user}
                  </Typography>
                </Box>
                <Typography color={colors.grey[100]} variant="body2">
                  {transaction.date}
                </Typography>
                <Box
                  backgroundColor={colors.greenAccent[500]}
                  p="5px 10px"
                  borderRadius="4px"
                >
                  ${transaction.cost}
                </Box>
              </Box>
            ))}
          </Box>
        </Grid>

        {/* ROW 3 */}
        <Grid item xs={12} md={6} lg={4}>
          <Box
            backgroundColor={colors.primary[400]}
            p="20px"
            borderRadius="12px"
            boxShadow={`0 4px 12px ${colors.grey[700]}`}
            display="flex"
            flexDirection="column"
            alignItems="center"
            height="100%"
          >
            <Typography variant="h6" fontWeight="600" mb="15px">
              Campaign Performance
            </Typography>
            <ProgressCircle size="225" />
            <Typography
              variant="h6"
              color={colors.greenAccent[500]}
              sx={{ mt: "15px" }}
            >
              $439,761 revenue generated
            </Typography>
            <Typography variant="body2" color={colors.grey[100]}>
              Includes marketing and promotional expenses
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <Box
            backgroundColor={colors.primary[400]}
            p="20px"
            borderRadius="12px"
            boxShadow={`0 4px 12px ${colors.grey[700]}`}
            display="flex"
            flexDirection="column"
            height="100%"
          >
            <Typography variant="h6" fontWeight="600" mb="15px">
              Sales Across Countries
            </Typography>
            <Box height="250px">
              <BarChart isDashboard={true} />
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12} lg={4}>
          <Box
            backgroundColor={colors.primary[400]}
            p="20px"
            borderRadius="12px"
            boxShadow={`0 4px 12px ${colors.grey[700]}`}
            height="100%"
          >
            <Typography variant="h6" fontWeight="600" mb="15px">
              Geography Based Traffic
            </Typography>
            <Box height="200px">
              <GeographyChart isDashboard={true} />
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Dashboard;
